@if (isReadonly()) {
  <div class="text-end" [attr.data-test]="getTestId(selectedTariffGroupId())">{{ selectedTariffOption()?.optionLabel }}</div>
} @else {
  <div ngbDropdown [autoClose]="true" placement="bottom-right" #dropdown #Dropdown="ngbDropdown" (keyup)="keyboardNavigation($event)">
    <button
      mweSetFocus
      class="btn px-2 w-100 justify-content-between btn-sm btn-dropdown-{{ colorCss }}"
      [id]="getTestId(selectedTariffGroupId())"
      [attr.data-test]="getTestId(selectedTariffGroupId())"
      role="combobox"
      aria-autocomplete="both"
      [attr.aria-owns]="dropdownId()"
      [attr.aria-activedescendant]="getOptionId('' + selectedOptionIndex()) || null"
      [attr.aria-labelledby]="ariaLabelledBy() || null"
      [attr.data-focus-key]="computedDataFocusKey()"
      ngbDropdownToggle
    >
      <span> <i class="mr-1 fa-solid fa-{{ selectedTariffOption()?.iconLabel }}"></i>{{ selectedTariffOption()?.optionLabel }} </span>
      <i [ngClass]="{ 'fa-chevron-up': Dropdown._open, 'fa-chevron-down': !Dropdown._open }" class="ml-2 fas" aria-hidden="true"></i>
    </button>

    <div
      [attr.id]="dropdownId()"
      #listbox
      role="listbox"
      ngbDropdownMenu
      class="dropdown-menu-tariff border border-2 border-{{ colorCss }} dropdown-menu-{{ colorCss }}"
    >
      @for (item of options(); track item.optionLabel) {
        <button
          [attr.id]="getOptionId('' + $index)"
          [ngClass]="{ active: isOptionActive(item) }"
          (click)="onOptionSelected(item)"
          [attr.data-test]="getTestId(item.option)"
          [attr.data-suggestion-index]="$index"
          role="option"
          tabindex="-1"
          class="dropdown-item dropdown-item-{{ colorCss }}"
        >
          @if (item.iconLabel) {
            <i class="mr-1 fa-solid fa-{{ item.iconLabel }}"></i>
          }
          {{ item.optionLabel }}

          @if (showDeltaUnit(item)) {
            ({{ item.delta }} {{ item.deltaUnit }})
          }
        </button>
      }
    </div>
  </div>
}
